import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep, setFormData } from '../../redux/slice/findJobSlice';
import Image from '../../components/general/Image';
import { EMPLOYMENT_TYPE } from '../../helpers/constants';
import Button from '../../components/general/Button';
import { toast } from 'react-toastify';

const StepOneForm = () => {
  const dispatch = useDispatch();
  const availability = useSelector(state => state.findJob.stepOneData.availability);

  const handleSelect = (value) => {
    dispatch(setFormData({ formData: { availability: value } }));
  }

  const handleSubmit = () => {
    if(!availability) {
      toast.error('Please select an availability');
      return;
    }

    dispatch(nextStep());
  }

  return (
    <div className='min-h-[60vh] !py-[50px] !pb-[80px] lg:flex lg:justify-between lg:gap-[30px]'>
      <div className='lg:w-[40%]'>
        <div>
          <p className='text-primary-color'> 1/8 </p>
          <h1 className="text-[1.6rem] font-semibold">
            <span className='lg:block'> What kind of project are you looking for?</span>
          </h1>
        </div>

        <div className='hidden lg:block mt-[20px] text-[#2A2A2A]'>
          <div className='mt-[20px] text-[#2A2A2A]'>
            <p> 2/8 </p>
            <h1 className="text-[1.6rem] font-semibold text-[#2A2A2A]">
              <span> What is your hourly rate </span>
              <span className='lg:block'>range?</span>
            </h1>
          </div>
          <div className='mt-[20px]'>
            <p> 3/8 </p>
            <h1 className="text-[1.6rem] font-semibold">
              <span> What is your main </span>
              <span className='lg:block'>specialization?</span>
            </h1>
          </div>
        </div>
      </div>

      <div className='lg:w-[60%]'>
        <div className='hidden lg:flex gap-[20px] text-[13px] mb-[100px]'>
          <p className='text-primary-color'> 1. Project Preferences </p>
          <p> 2. Specialization in stack </p>
          <p> 3. Additional info </p>
          <p> 4. Registration </p>
        </div>
        <div className='flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-[20px] '>
          {
            Object.keys(EMPLOYMENT_TYPE).map((key) => {
              return (
                <div key={key} className={`bg-[#292929] rounded-[6px] flex items-center gap-4 justify-start p-[10px] lg:p-[20px] cursor-pointer ${availability === key ? 'border border-primary-color bg-black' : ''}`} onClick={() => handleSelect(key)}>
                  <Image className='w-[20px]' src={EMPLOYMENT_TYPE[key].image} alt={EMPLOYMENT_TYPE[key].displayValue} />

                  <div>
                    <h3 className='text-[18px] lg:text-[1rem] font-bold'>{EMPLOYMENT_TYPE[key].displayValue}</h3>
                    <p className='text-[14px] lg:text-[0.7rem] mt-[5px] font-light'>{EMPLOYMENT_TYPE[key].secondaryText}</p>
                  </div>
                </div>
              )
            })
          }

        </div>
        <Button onClick={handleSubmit} className='w-full bg-primary-color text-black h-[40px] lg:h-[50px] text-[18px] lg:text-[20px] lg:mx-auto rounded mt-[20px] md:w-[200px] lg:mt-[50px]' disabled={!Boolean(availability)}>Ok, next <i className="fa-solid fa-arrow-up-right" /></Button>
      </div>
    </div>

  )
}

export default StepOneForm;